import { render } from "./AiBriefingPanel.vue?vue&type=template&id=49834e29&scoped=true"
import script from "./AiBriefingPanel.vue?vue&type=script&lang=js"
export * from "./AiBriefingPanel.vue?vue&type=script&lang=js"

import "./AiBriefingPanel.vue?vue&type=style&index=0&id=49834e29&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49834e29"]])

export default __exports__